import allImgPaths from 'assets/images';
import CustomDropdown from 'components/common/dropdown/Dropdown'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { RFP_FILTERS } from 'utils/constant';
import { getDocumentForComparison } from 'services/event';
import { useParams } from 'react-router-dom';
import { isArray } from 'lodash';

const RfpSummary = ({ messageData = {} }: any) => {
    const { id: eventId } = useParams();
    const [documentsData, setDocumentsData] = useState<any>([])
    const [selectedData, setSelectedData] = useState<any>(null)
    const {
        control
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            teamEmail: { value: "", label: "" },
            assignTask: { value: "", label: "" }
        }
    });

    useEffect(() => {
        fetchDocumentsData()
    }, [])

    const fetchDocumentsData = async () => {
        const payload = {
            event_id: eventId,
            type: 'summary'
        }
        const { data } = await getDocumentForComparison(payload);
        const updatedData = data;

        setDocumentsData(updatedData)
    }


    const [selectedValue, setSelectedValue] = useState<any>(null);

    const CustomPlaceholder = () => (
        <div className="flex items-center justify-between gap-x-2">
            <img src={allImgPaths.filterIcon} alt="" />
            <span className="text-[#344054] font-interSemiBold" >Filter for</span>
        </div>
    );

    const handleSelection = (index: number, isChecked: boolean) => {
        setSelectedData(documentsData[index])
    }

    return (
        <>
            {
                documentsData?.length > 0 &&
                <>
                    <div className="mb-10">
                        <div className='flex gap-x-3 items-center justify-between mb-2.5'>

                            <div className='flex gap-x-3 items-center'>
                                <button className=" text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide !text-base flex items-center bg-white home-dropdown rfp-dropdwon">
                                    <CustomDropdown
                                        name="rfp_fiter"
                                        control={control}
                                        placeholder={<CustomPlaceholder />}
                                        selectedValue={selectedValue}
                                        onChange={() => { }}
                                        options={RFP_FILTERS}
                                    />
                                </button>

                                <div className="border border-[#D0D5DD] rounded-lg w-60 py-2 px-3.5 flex items-center gap-x-2">
                                    <img src={allImgPaths.searchIcon} alt="search" />
                                    <input
                                        className="w-full"
                                        placeholder="Search for Vendor"
                                        type="text"
                                        onChange={() => { }}
                                        value={''}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="border border-[#EAECF0] rounded-tl-xl rounded-tr-xl">
                            <div className="bg-[#F2F4F7] rounded-tl-xl rounded-tr-xl custom-rfp-table-grid">
                                <div className="flex items-center gap-x-4 py-3 px-6">
                                    <span className='text-sm font-interMedium text-[#475467] ml-8'>Vendor</span>
                                </div>

                                {/* <div className="py-3 px-6">
                                    <span className='text-sm font-interMedium text-[#475467]'>Total Interactions</span>
                                </div> */}

                                <div className="py-3 px-6">
                                    <span className='text-sm font-interMedium text-[#475467]'>Service categories</span>
                                </div>
                            </div>
                            <div className="overflow-y-scroll max-h-52">
                                {
                                    documentsData?.length > 0 && documentsData.map((item: any, index: any) => (
                                        <React.Fragment key={index}>
                                            <div className="custom-rfp-table-grid border-b border-[#EAECF0]">
                                                <div className="flex items-center gap-x-4 py-3 px-6">
                                                    <input
                                                        type="radio"
                                                        id={item?.file_name || ''}
                                                        name={item?.file_name || ''}
                                                        onChange={(e: any) => handleSelection(index, e.target.checked)}
                                                        checked={JSON.stringify(selectedData?._id) == JSON.stringify(item?._id)}
                                                    />

                                                    <div className="flex gap-x-3">
                                                        <div className="">
                                                            <p className='text-sm font-interMedium text-[#475467] mb-0.5'>
                                                                {item.file_name}
                                                            </p>
                                                            {/* <p className='text-sm text-[#475467]'>{item.size}</p> */}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div className="py-3 px-6 flex items-center pl-20">
                                                    <span className='text-sm text-[#475467]'>2</span>
                                                </div> */}

                                                <div className="py-3 px-7 flex items-center">
                                                    {
                                                        item?.rfp_categories && isArray(item?.rfp_categories) &&
                                                        <span className='text-sm text-[#475467]'>
                                                            {item.rfp_categories.join(', ')}
                                                        </span>
                                                    }
                                                    {
                                                        !item?.rfp_categories?.length && <span>-</span>
                                                    }
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    {
                        selectedData &&
                        <div className="border border-[#D0D5DD] rounded-lg px-6 py-5 mt-10 mb-5 ">
                            <div className='mt-5'>
                                <span><strong>Summary</strong></span>
                                <p className='text-[#101828] text-base pb-4'>
                                    {selectedData?.summarized_data?.summary}
                                </p>
                            </div>
                            <div className='mt-5'>
                                <span><strong>Key Points</strong></span>
                                <p className='text-[#101828] text-base pb-4'>
                                    <ul>
                                        {
                                            selectedData?.summarized_data?.key_points && selectedData?.summarized_data?.key_points?.length > 0 &&
                                            selectedData?.summarized_data?.key_points.map((sd: any, sdIndex: number) => (
                                                <li key={sdIndex} className='flex'>
                                                    <strong>{sdIndex + 1}</strong>
                                                    &nbsp;
                                                    <p>{sd}</p>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </p>
                            </div>
                        </div>
                    }
                </>
            }

            {
                documentsData?.length == 0 &&
                <div className='item-center justify-between m-10'>
                    <p>Nothing to Summarize</p>
                </div>
            }
        </>
    )
}

export default RfpSummary